import { Troubleshoot } from "@mui/icons-material";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { EegDataRecord, EEGMetric, EEGRecording, PairFrequencyBand } from "../types";
import { MetricCard } from "./MetricCard";
import { mainColor, secondaryColor } from "../../../../theme";
import { useAllEegData } from "../utils/useEeegData";

type GlobalStateCardProps = {
    showDataInTable: (metricName: string, rawData: Array<EegDataRecord>) => void;
    metrics: Array<EEGMetric>;
    firstEEG: EEGRecording;
    secondEEG: EEGRecording;
    bandFrequencyPairs: Array<PairFrequencyBand>;
    allEegData: ReturnType<typeof useAllEegData>;
};

export const GlobalStateCard = ({ showDataInTable, metrics, firstEEG, secondEEG, bandFrequencyPairs, allEegData }: GlobalStateCardProps) => {

    const categorizedMetrics = {
        general: metrics.filter((metric) => metric.category === "general"),
        connectivity: metrics.filter((metric) => metric.category === "connectivity"),
        bursts: metrics.filter((metric) => metric.category === "bursts"),
        individualHz: metrics.filter((metric) => metric.category === "individual_hz"),
    };

    const renderCategoryRow = (category: string, categoryMetrics: Array<EEGMetric>) => {
        if (categoryMetrics.length === 0) return null;

        return (
            <Box key={category} mb={3}>
                <Typography variant="h6" fontWeight="bold" mb={1}>
                    {category.charAt(0).toUpperCase() + category.slice(1)}
                </Typography>
                <Box display="flex" gap={2}>
                    {categoryMetrics.map((metric) => {
                        return (
                            <MetricCard
                                key={metric.id}
                                metric={metric}
                                showDataInTable={showDataInTable}
                                firstEEG={firstEEG}
                                secondEEG={secondEEG}
                                bandFrequencyPairs={bandFrequencyPairs}
                                allEegData={allEegData}
                            />
                        );
                    })}
                </Box>
            </Box>
        );
    };

    return (
        <Card
            sx={{
                background: `linear-gradient(to right, ${secondaryColor}, ${mainColor})`,
                color: "white",
                mb: 4,
                p: 2,
            }}
        >
            <CardContent>
                <Box display="flex" alignItems="center" mb={3}>
                    <Troubleshoot sx={{ mr: 1, fontSize: 30 }} />
                    <Typography variant="h5" fontWeight="bold">
                        Global Z-Score Means
                    </Typography>
                </Box>
                {renderCategoryRow("general", categorizedMetrics.general)}
                {renderCategoryRow("bursts", categorizedMetrics.bursts)}
                {renderCategoryRow("connectivity", categorizedMetrics.connectivity)}
                {renderCategoryRow("individual_hz", categorizedMetrics.individualHz)}
            </CardContent>
        </Card>
    );
};
